var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"issues-bar-chart-container"},[_c('div',{staticClass:"issues-bar-chart"},[_vm._l((_vm.series),function(i,index){return _c('div',{key:index + i.name,staticClass:"issues-bar-chart__category-item color-tab",style:({
        display: 'inline-block',
        width: i.data[0] + '%',
        backgroundColor: _vm.colors[i.colorIndex],
      })})}),_c('div',{staticClass:"issues-bar-chart__label-container row no-gutters"},_vm._l((_vm.series),function(i,index){return _c('div',{key:index + i.name + 'label',staticClass:"issues-bar-chart__category-label col-md-4",style:({
          borderLeft: ("6px solid " + (_vm.colors[i.colorIndex]))
        })},[_c('h4',{staticClass:"p-0 m-0",style:({
            color: _vm.colors[i.colorIndex],
          })},[_vm._v(" "+_vm._s(i.data[0].toFixed(2))+"% ")]),_c('div',[_vm._v(" "+_vm._s(i.name)+" ")])])}),0)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }